// extracted by mini-css-extract-plugin
export default {"ar":"AR_ar__Qs6ff","warning":"AR_warning__ywHCc"};